import { useCallback } from "react";
import { Button } from "~/components/ui/button";
import { useConfirmationDialog } from "~/components/ui/confirmationDialog";

type NavigateToButtonProps = {
  showAdditionalAddressWarning?: boolean;
  coordinate: {
    latitude: number;
    longitude: number;
  };
  address?: string | null;
};

export const NavigateToButton = ({
  coordinate,
  address,
  showAdditionalAddressWarning,
}: NavigateToButtonProps) => {
  const latLng = `${coordinate.latitude},${coordinate.longitude}`;
  const encodedAddress = address ? encodeURIComponent(address) : null;
  const url = `https://www.google.com/maps/dir/?api=1&destination=${
    encodedAddress ?? latLng
  }`;

  const { showConfirmationDialog } = useConfirmationDialog();

  const handleNavigateWithConfirmation = useCallback(() => {
    showConfirmationDialog({
      title: "Warning",
      text: "This request has additional address info that needs to be reviewed before navigating",
      onConfirm: () => window.open(url, "_blank", "noopener,noreferrer"),
    });
  }, [url, showAdditionalAddressWarning, showConfirmationDialog]);

  if (showAdditionalAddressWarning) {
    return (
      <Button
        variant="tertiary"
        fullWidth
        onClick={handleNavigateWithConfirmation}
      >
        Navigate to
      </Button>
    );
  }

  return (
    <Button
      variant="tertiary"
      fullWidth
      href={url}
      rel="noopener noreferrer"
      target="_blank"
    >
      Navigate to
    </Button>
  );
};
